module.exports = __webpack_public_path__ + "static/media/blog-image-2.97b3d560.svg";